import { Checkbox, CheckboxGroup, Stack } from '@chakra-ui/react';
import { Controller, FieldPath, UseFormReturn } from 'react-hook-form';
import { AdhocSupportedInterval } from 'constants/adhocSupportedInterval';

type Props<TFieldValues> = {
  name: FieldPath<TFieldValues>;
  control: UseFormReturn<TFieldValues>['control'];
};

export const AdhocSupportedIntervalCheckboxGroup = <TFieldValues,>({
  name,
  control,
}: Props<TFieldValues>) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { ref: _, value, ...rest } }) => (
      <CheckboxGroup value={value as AdhocSupportedInterval[]} {...rest}>
        <Stack spacing={8} direction="row">
          <Checkbox value="hourly">hourly</Checkbox>
          <Checkbox value="daily">daily</Checkbox>
          <Checkbox value="weekly">weekly</Checkbox>
          <Checkbox value="monthly">monthly</Checkbox>
          <Checkbox value="none">手動実行のみ</Checkbox>
        </Stack>
      </CheckboxGroup>
    )}
  />
);
